import { alpha } from '@mui/material';
import { styled } from '@mui/material';
import { useIsMac } from './useIsMac';

type KeycodeProps = {
  size?: 'small' | 'medium';
};

export const KeyCode = ({
  children,
  size = 'medium',
}: KeycodeProps & { children: React.ReactNode }) => {
  return <StyledRoot className={size}>{children}</StyledRoot>;
};

KeyCode.CtrlOrCmd = (props: KeycodeProps) => {
  const isMac = useIsMac();
  return <KeyCode {...props}>{isMac ? '⌘' : 'Ctrl'}</KeyCode>;
};

const StyledRoot = styled('div')(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 400,
  color: 'white',
  borderRadius: 4,
  backgroundColor: alpha(theme.palette.common.white, 0.08),
  border: `.5px solid ${alpha(theme.palette.common.white, 0.16)}`,
  minWidth: 24,
  height: 24,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  lineHeight: 1,
  padding: theme.spacing(0.5),

  '&.small': {
    fontSize: '0.625rem',
    minWidth: 16,
    height: 16,
  },
}));
